import React, { useEffect, useState } from "react";
import { Button, Col, Container, Label, Row } from "reactstrap";
import { useDispatch } from "react-redux";
import { ThunkDispatch } from "redux-thunk";
import { setAuthenticated } from "../redux/slices/loginSlice";
import { LOGIN_STATUS } from "../utils/Constant";
import { toast } from "react-toastify";
import { UserManager, User } from "oidc-client-ts";
import oidcConfig from "../utils/AuthConfig";
import { refreshAuthToken } from "../utils/AuthUtils";
import { useNavigate } from "react-router-dom";

const LoginPage: React.FunctionComponent = () => {
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>();
  const userManager = new UserManager(oidcConfig);
  const navigate = useNavigate();
  const [loading, setLoading] = useState<boolean>(true);

  const checkAuthentication = async () => {
    try {
      const user = await userManager.getUser();
      if (user && user.access_token) {
        // console.log("User already authenticated:", user);
        onSuccessfulLogin(user);
      } else {
        // console.log("User not authenticated, redirecting to login...");
        callLogin();
      }
    } catch (error) {
      console.error("Error checking authentication:", error);
      callLogin();
    }
  };

  const callLogin = () => {
    userManager
      .signinRedirect()
      .then(() => {
        console.log("Login initiated");
      })
      .catch((error) => {
        console.error("Login error:", error);
      });
  };

  const handleCallback = async () => {
    try {
      const user = await userManager.signinRedirectCallback();
      if (user) {
        //console.log("Callback successful, user authenticated:", user);
        onSuccessfulLogin(user);
      }
    } catch (error) {
      console.error("Callback processing error:", error);
    }
  };

  useEffect(() => {
    const isCallbackUrl = window.location.href.includes("code=");
    
    if (isCallbackUrl) {
      // Only process the callback if the user was redirected from login
      // console.log("Processing authentication callback...");
      handleCallback();
    } else {
      // Check authentication status before redirecting to login
      setTimeout(()=>{
        checkAuthentication();
      },500)
    }
  }, []);

  const onSuccessfulLogin = async (payload: User) => {
    const AT = payload.access_token;
    const tokenPayload = JSON.parse(atob(AT.split(".")[1]));
    let CURRENT_ENV = process.env.REACT_APP_ENV || "development";

    // if (
    //   (CURRENT_ENV === "uat" && !tokenPayload.groups.includes("CHMS OPS")) ||
    //   (CURRENT_ENV === "preprod" &&
    //     !tokenPayload.groups.includes("chms-ops-preprod")) ||
    //   (CURRENT_ENV === "production" &&
    //     !tokenPayload.groups.includes("chms-ops-prod")) ||
    //   (CURRENT_ENV === "development" &&
    //     !tokenPayload.groups.includes("CHMS OPS"))
    // ) {
    //   toast.error("Access denied. Unauthorized group.");
    //   return;
    // }

    const data = {
      employeeName: payload.profile.name,
      email: payload.profile.email,
      accessToken: payload.access_token,
      accessExpiryTime: payload.expires_at,
      resetToken: payload.refresh_token,
      resetExpiryTime: payload.expires_at,
      mobile_device_token: null,
      groupname: tokenPayload.groups,
    };

    toast.success("Logged in successfully");
    dispatch(
      setAuthenticated({
        status: LOGIN_STATUS.AUTHENTICATED,
        user: data,
      })
    );

    await refreshAuthToken(data.resetToken);
    navigate("/home", { replace: true }); // Redirect to home page after login
  };

  return (
    <Container className="p-0 m-0 login-parent">
      <Row className="p-0 m-0">
        <Col md={6} className="p-0 m-0 position-relative">
          <div className="position-relative image-parent-height">
            <div className="bg-overlay position-absolute top-0 start-0 w-100 image-parent-height" />
            <div className="position-absolute welcome-parent">
              {/* <div className="text-left">
                <Label className="welcome">Welcome to</Label>
                <Label className="fieldAssist mt-n25">KSHEMA GPT</Label>
              </div> */}
            </div>
          </div>
        </Col>
        <Col md={6} className="p-3 m-0">
          <div className="m-5">
            <Button
              variant="success"
              size="lg"
              className="login-button"
              disabled={loading}
              onClick={callLogin}
            >
           Loading...
            </Button>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default LoginPage;
